export const NOTIFICATION_TYPES = [
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_CREATED',
    value: 'conversation_creation',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_ASSIGNED',
    value: 'conversation_assignment',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_MENTION',
    value: 'conversation_mention',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.ASSIGNED_CONVERSATION_NEW_MESSAGE',
    value: 'assigned_conversation_new_message',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PARTICIPATING_CONVERSATION_NEW_MESSAGE',
    value: 'participating_conversation_new_message',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_FIRST_RESPONSE',
    value: 'sla_missed_first_response',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_NEXT_RESPONSE',
    value: 'sla_missed_next_response',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_RESOLUTION',
    value: 'sla_missed_resolution',
  },
  // Advup: tipos custom (pipeline / processos / agenda / lead)
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PIPELINE_CARD_ASSIGNED',
    value: 'pipeline_card_assigned',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PIPELINE_CARD_MOVED',
    value: 'pipeline_card_moved',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PIPELINE_CARD_WON',
    value: 'pipeline_card_won',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PIPELINE_CARD_LOST',
    value: 'pipeline_card_lost',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PIPELINE_SLA_EXCEEDED',
    value: 'pipeline_sla_exceeded',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.LEGAL_PROCESS_NEW_MOVEMENT',
    value: 'legal_process_new_movement',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.LEGAL_NEW_PUBLICATION',
    value: 'legal_new_publication',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.LEGAL_ACTIVITY_REMINDER',
    value: 'legal_activity_reminder',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.LEGAL_FATAL_DEADLINE',
    value: 'legal_fatal_deadline',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.LEAD_BECAME_HOT',
    value: 'lead_became_hot',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.FINANCIAL_OBLIGATION_OVERDUE',
    value: 'financial_obligation_overdue',
  },
  // Alertas do sistema (23/09/2026): chegam sempre no sino de quem foi
  // escolhido em Configurações › Alertas; aqui a pessoa decide se também quer
  // por e-mail/push. Os URGENTES vão por e-mail sempre — não entram aqui.
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.ALERTA_DO_SISTEMA',
    value: 'alerta_do_sistema',
  },
];

export const EVENT_TYPES = {
  ASSIGNED: 'assigned',
  NOTME: 'notme',
  UNASSIGNED: 'unassigned',
};

export const ALERT_EVENTS = [
  {
    value: EVENT_TYPES.ASSIGNED,
    label: 'assigned',
  },
  {
    value: EVENT_TYPES.UNASSIGNED,
    label: 'unassigned',
  },
  {
    value: EVENT_TYPES.NOTME,
    label: 'notme',
  },
];
